export const unknownString = 'unknown';



// WEBPACK FOOTER //
// ../../src/consts.ts